import { useState } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';
import { InputFields } from '../FormPillInputComponent';

export function usePillInputLogic(regexpValidation: RegExp | string) {
  const [value, setValue] = useState('');
  const [inputError, setInputError] = useState('');

  const submitChange = (
    newValue: string,
    field: ControllerRenderProps<
      PlannerConfigEntityWithOptionalFields,
      InputFields
    >,
    currentValues: string[],
  ) => {
    if (!newValue) {
      return;
    }
    const trimmedValue = newValue.trim().replace(/\s+/g, ' ');
    const isValid = new RegExp(regexpValidation).test(trimmedValue);
    const alreadyExist = currentValues.some((x) => x === trimmedValue);

    if (alreadyExist) {
      setInputError(`${trimmedValue} already exists`);
      return;
    }
    if (!isValid) {
      setInputError(`Invalid format: ${trimmedValue}`);
      return;
    }

    const updatedValues = [...currentValues, trimmedValue];
    const isStringType = typeof field.value === 'string';
    const finalValue = isStringType ? updatedValues.join(',') : updatedValues;

    field.onChange(finalValue);
    setValue('');
    setInputError('');
  };

  const handleDelete = (
    item: string,
    field: ControllerRenderProps<
      PlannerConfigEntityWithOptionalFields,
      InputFields
    >,
    currentValues: string[],
  ) => {
    const newValues = currentValues.filter((value) => value !== item);
    const isStringType = typeof field.value === 'string';
    const finalValue = isStringType ? newValues.join(',') : newValues;
    field.onChange(finalValue);
  };

  return {
    value,
    setValue,
    inputError,
    setInputError,
    submitChange,
    handleDelete,
  };
}
